import { render, staticRenderFns } from "./index.vue?vue&type=template&id=64aff05a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64aff05a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64aff05a')) {
      api.createRecord('64aff05a', component.options)
    } else {
      api.reload('64aff05a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=64aff05a&scoped=true", function () {
      api.rerender('64aff05a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mp/wx-account-tag/index.vue"
export default component.exports